export function FlickrSlideShow(str: string) {
  //Detect
  let gallerpattern = /<object.+data=\"http:\/\/www.flickr.com.+<\/object>/g
  let setpattern = /[^set_id\=?][0-9]+(?=&amp;)/g

  let galleryMatch = str.match(gallerpattern)
  if (galleryMatch != null) {
    console.log('found - flickr gallery')
    galleryMatch.map((m, index) => {
      let setidMatch = m.match(setpattern)
      let flickrConvert =
        '<iframe style="position: relative; top: 0; left: 0; width: 100%; height: 100%;" src="https://flickrembed.com/cms_embed.php?source=flickr&layout=responsive&input=%set_id%&sort=0&by=album&theme=tiles_nested&scale=fill&speed=3000&limit=10&skin=default&autoplay=true" scrolling="no" frameborder="0" allowFullScreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"><p><a  href="https://www.sellcompare.co.uk/">Sell Compare UK</a></p><small>Powered by <a href="https://flickrembed.com">flickr embed</a>.</small></iframe><script type="text/javascript">function showpics(){var a=$("#box").val();$.getJSON("http://api.flickr.com/services/feeds/photos_public.gne?tags="+a+"&tagmode=any&format=json&jsoncallback=?",function(a){$("#images").hide().html(a).fadeIn("fast"),$.each(a.items,function(a,e){$("<img/>").attr("src",e.media.m).appendTo("#images")})})}</script>'
      if (setidMatch != null) {
        console.log(setidMatch[0])
        flickrConvert = flickrConvert.replace('%set_id%', setidMatch[0])
        str = str.replace(m, flickrConvert)
      }
    })
  }
  return str
}

export default function CleanUp(str: string) {
  str = FlickrSlideShow(str)
  console.log(str)
  return str
}

export function GetValuesInBody(body:string)
{

}
